import { Box, ButtonNew, ColorOptions, Icon, Image, Spacer, Text, TextNew } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useState } from 'react'
import { Animated, FlatList } from 'react-native'
import { jiopayBusinessProductData, pgProductData } from '../../static/staticData'
import { colors } from '../../util/colors'
import { openPlayStore } from '../ProductsMegaMenu'
import { ToolTipBorder } from '../ToolTipBorder'
import { styles } from './styles'

const Products = ({ hide, close }: any) => {
  const { navigate } = useNavigation()

  const [expanded, setIsExpanded] = useState(false)
  const [animatedValue] = useState<any>(new Animated.Value(0))

  if (hide) {
    return null
  }

  const onKnowmorePress = () => {
    navigate('jio-pay-business')
    close()
  }

  const renderPgProductItem = ({ item }: any) => {
    const handleNavigation = () => {
      navigate(item?.path)
      close()
    }
    const Component: any = item.component

    return (
      <>
        <Box onPress={handleNavigation} {...styles.itemContainer} f={1} margin={8} p={8}>
          {!!item.component && <Component height={24} width={24} />}
          {!!item.icon && typeof item.icon !== 'string' && <Image source={item?.icon} height={24} width={24} />}
          {item.icon &&
            typeof item.icon === 'string' &&
            (item.icon.length > 100 ? (
              <Image source={item?.icon} height={24} width={24} />
            ) : (
              <Icon id={item.icon as any} color={'BLUE_SHADE_PRIMARY'} size={24} />
            ))}
          <Spacer size={8} direction={'horizontal'} />
          <Text title={item.headerText} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'} />
        </Box>
      </>
    )
  }

  const startProductsAnimation = (hide: boolean) => {
    Animated.timing(animatedValue, {
      toValue: expanded ? 0 : 320,
      duration: 600,
      useNativeDriver: true,
    }).start(hide ? () => setIsExpanded(false) : () => {})
  }
  const renderItem = ({ item }: any) => {
    const handleNavigation = () => {
      close()
      navigate(item?.path)
    }

    const handleExpandProducts = () => {
      if (item?.headerText === 'Payment Gateway') {
        !expanded && setIsExpanded(!expanded)
        startProductsAnimation(expanded)
      }
    }
    const Component = item.component
    return (
      <>
        <Box onPress={handleNavigation} {...styles.itemContainer} pl={32} bg={'WHITE'}>
          {!!Component && <Component height={32} width={32} />}
          {!!item?.icon && <Image source={item?.icon} height={32} width={32} />}
          <Spacer size={16} direction={'horizontal'} />
          <Text title={item.headerText} fontFamily={'jiotype-medium'} fontSize={14} color={'BLACK_21'} />
        </Box>
        {item?.headerText === 'Payment Gateway' && (
          <Box {...styles.itemContainer} pl={80} bg={'WHITE'} pt={0} onPress={handleExpandProducts}>
            <Text
              title={expanded ? 'Hide Products' : 'Explore Products'}
              fontFamily={'jiotype-medium'}
              fontSize={12}
              color={colors.HIGHLIGHT as ColorOptions}
            />
            {item?.headerText === 'Payment Gateway' && <Spacer size={4} direction={'horizontal'} />}
            {item?.headerText === 'Payment Gateway' && (
              <Icon id={expanded ? 'ARROW_UP' : 'ARROW_DOWN'} color={colors.HIGHLIGHT as ColorOptions} size={24} />
            )}
          </Box>
        )}

        {expanded && item?.headerText === 'Payment Gateway' && (
          <Animated.View style={{ maxHeight: animatedValue }}>
            <ToolTipBorder left={80}>
              <Box
                p={24}
                bg={colors.HOVER_SOLID as ColorOptions}
                borderBottomWidth={1}
                borderBottomColor={colors.HOVER_SOLID as ColorOptions}>
                <FlatList data={pgProductData(false)} renderItem={renderPgProductItem} numColumns={2} />
              </Box>
            </ToolTipBorder>
          </Animated.View>
        )}
      </>
    )
  }
  return (
    <>
      <Box>
        <FlatList data={jiopayBusinessProductData(true)} renderItem={renderItem} />
        <Spacer size={38} direction={'vertical'} />
      </Box>
      {!expanded && (
        <Box {...styles.footerView}>
          <Box {...styles.leftImgContainer}>
            <Box {...styles.jioBizImageContainer}>
              <Image
                resizeMode="contain"
                source={require('../../assets/images/jio-pay.png')}
                width={120}
                height={110}
              />
            </Box>
            <Box {...styles.businessAppContainer}>
              <TextNew {...styles.boldHeader(hide)} title={'JioPay Business App'} />
              <Spacer size={5} />
              <TextNew {...styles.footerDescription} title={'Simple, instant UPI payments from your customers'} />
            </Box>
          </Box>
          <Box {...styles.googlePlayView}>
            <Box {...styles.underlayedTrans} onPress={openPlayStore}>
              <Image
                source={require('../../assets/images/google-play.png')}
                {...styles.imgStyle}
                resizeMode={'contain'}
              />
            </Box>
            <Spacer size={20} direction="horizontal" />
            <ButtonNew
              title={'Know More'}
              height={32}
              onPress={onKnowmorePress}
              width={110}
              color={'transparent'}
              textType="bodyMedium12"
              titleColor={colors.HIGHLIGHT}
              borderRadius={4}
              borderColor={colors.HIGHLIGHT}
              type="secondary"
            />
          </Box>
        </Box>
      )}
    </>
  )
}
export { Products }
